export default __webpack_public_path__ + "static/media/alice_ball.a09a3e2e.jpg";